import { FormPageProperty } from 'shared';

export const RE_ENTER_PROPERTY_ID_PREFIX = '__RE_ENTER_PROPERTY_ID_PREFIX__';
export const getReEnterPropertyId = (
  propertyId: FormPageProperty['propertyId'],
): string => `${RE_ENTER_PROPERTY_ID_PREFIX}${propertyId}`;
